import React, { useEffect, useRef, useState } from "react";

// Edit { start, end } as two side-by-side date inputs. Display shows the
// range like "Jan 5 → Jan 12" with the bar fully rendered in TimelineView.
function toInput(d) {
  if (!d) return "";
  const x = new Date(d);
  if (Number.isNaN(x.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${x.getFullYear()}-${pad(x.getMonth() + 1)}-${pad(x.getDate())}`;
}
function fmt(d) {
  if (!d) return "";
  const x = new Date(d);
  return x.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export default function TimelineCell({ value, readOnly, onCommit }) {
  const [editing, setEditing] = useState(false);
  const [start, setStart] = useState(toInput(value?.start));
  const [end, setEnd] = useState(toInput(value?.end));
  const ref = useRef(null);

  useEffect(() => {
    setStart(toInput(value?.start));
    setEnd(toInput(value?.end));
  }, [value]);

  useEffect(() => { if (editing) ref.current?.focus(); }, [editing]);

  const commit = () => {
    setEditing(false);
    if (!start || !end) {
      if (value) onCommit(null);
      return;
    }
    const s = new Date(start).toISOString();
    const e = new Date(end).toISOString();
    if (new Date(s).getTime() > new Date(e).getTime()) return;
    if (s === value?.start && e === value?.end) return;
    onCommit({ start: s, end: e });
  };

  if (editing && !readOnly) {
    return (
      <div className="cell-display timeline-edit">
        <input
          ref={ref}
          type="date"
          className="cell-input"
          value={start}
          onChange={(e) => setStart(e.target.value)}
        />
        <span className="arrow">→</span>
        <input
          type="date"
          className="cell-input"
          value={end}
          onChange={(e) => setEnd(e.target.value)}
          onBlur={commit}
          onKeyDown={(e) => { if (e.key === "Enter") commit(); if (e.key === "Escape") setEditing(false); }}
        />
      </div>
    );
  }

  return (
    <div
      className={`cell-display timeline ${readOnly ? "read-only" : ""}`}
      onClick={() => !readOnly && setEditing(true)}
    >
      {value?.start && value?.end ? (
        <span>{fmt(value.start)} → {fmt(value.end)}</span>
      ) : (
        <span className="placeholder">—</span>
      )}
    </div>
  );
}
